<template>
<div>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="75"
  >
    <v-menu
      bottom
      right :disabled="$route.hash === '#tutorial'"
      offset-y
      origin="top right"
      transition="slide-x-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn color="grey darken-2"
          v-on="on"
          class="mr-3" text
          fab
          small
        >
          <v-icon size="28">
            mdi-menu
          </v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        dense
      >
        <div>
          <app-bar-item to="/help">
            <v-list-item-title>Help With Billit</v-list-item-title> <v-icon small>mdi-help</v-icon>
          </app-bar-item>
          <app-bar-item @click.native="dialog = true">
            <v-list-item-title class="mr-2">Report an Issue </v-list-item-title> <v-icon>mdi-bug</v-icon>
          </app-bar-item>
          <app-bar-item to="/#tutorial">
            <v-list-item-title>View Tutorial</v-list-item-title> <v-icon small>mdi-text-box-multiple-outline</v-icon>
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>
    

    <v-toolbar-title class="hidden-sm-and-down font-weight-light">
      {{ $route.name }}
      <!-- <v-breadcrumbs :items="breadcrumbs">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            class="font-weight-bold"
            :to="item.to"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs> -->
    </v-toolbar-title>

    <v-spacer />

    <!-- billit build only: -->
    <!-- <v-text-field
      label="Search"
      color="black"
      hide-details
      outlined
      dense
      style="max-width: 300px;"
      append-icon="mdi-magnify"
    >
    </v-text-field> -->

    <div class="mx-5" />

    <v-menu
      bottom
      left :disabled="$route.hash === '#tutorial'"
      offset-y
      origin="top right"
      transition="slide-x-reverse-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          min-width="0"
          height="50"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon size="28" style="margin-right: 5px; margin-top: 1px;">mdi-account-outline</v-icon>
          <span class="text-capitalize font-weight-light" style="font-size: 18px;">{{ $store.state.user.displayName }}</span>
          <v-icon size="22" class="mr-n2 ml-3">mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list
        :tile="false"
      >
        <div>
          <app-bar-item
            v-for="(n, i) in items"
            :key="`item-${i}`"
            :to="n.to"
          >
            <v-list-item-icon><v-icon v-text="n.icon"></v-icon></v-list-item-icon>
            <v-list-item-title v-text="n.title" />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>

    <!-- <v-btn
      class="ml-2"
      min-width="0"
      text
      to="/account"
    >
      <v-icon size="32">mdi-account</v-icon>
    </v-btn> -->
    <v-dialog v-model="dialog" transition="slide-y-reverse-transition" :persistent="loading" max-width="500">
      <v-card>
        <v-card-title>
          Report an Issue
          <v-spacer />
          <v-icon aria-label="Close" @click="dialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="body-1 text-center">
          <v-form>
            <v-select
              outlined dense v-model="target"
              label="What Platform" :items="['Billit Dashboard', 'Billit Build', 'Authentication', 'Billing']"
            ></v-select>
            <v-select
              outlined dense v-model="emotion"
              label="How Are You Feeling?" :items="['Angry', 'Excited', 'Confused', 'Worried', 'Panicked', 'Upset']"
            ></v-select>
            <v-text-field
              outlined dense v-model="subject"
              label="Subject"
            ></v-text-field>
            <v-textarea
              outlined dense v-model="message"
              label="Message" placeholder="A message describing what happened, where in the software, and when. Additionally, feel free to leave any suggestions or improvements for the Billit experience!"
            ></v-textarea>
          </v-form>

          <v-btn
            class="mt-3 font-weight-medium"
            color="info"
            depressed
            default
            :loading="loading"
            rounded
            @click="reportIssue"
          >Report</v-btn>
          <p v-if="feedback" class="mt-5 red--text">{{ feedback }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app-bar>
  <v-snackbar
      v-model="snaccbar" color="primary"
      multi-line :timeout="6000" class="font-weight-medium mb-6"
    >
      Your report has been submitted successfully. Thanks for your feedback!
      <v-btn color="white" icon @click="snaccbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import { functions } from "@/firebase"
  // Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'billit elevation-5': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      snaccbar: false,
      loading: false,
      feedback: '',
      dialog: false,
      subject: '',
      emotion: '',
      message:  '',
      target: 'Billit Dashboard',
      items: [
        {
          icon: "mdi-account-outline",
          title: "My Account",
          to: "/account"
        },
        {
          title: "Help & FAQ",
          icon: "mdi-book-multiple-outline",
          to: "/help"
        },
        // {
        //   title: "Documentation",
        //   icon: "mdi-book-multiple-outline",
        //   to: "/docs"
        // },
        {
          title: "Changelog",
          icon: "mdi-timeline-text-outline",
          to: "/changelog"
        },
      ],
    }),
    mounted() {
      this.$root.$on('openReportIssue', () => this.dialog = true)
    },
    methods: {
      reportIssue() {
        if (this.target && this.subject && this.message) {
          this.feedback = ''
          this.loading = true
          let f = functions.httpsCallable('reportIssue')
          const { subject, message, emotion, target } = this.$data
          f({ emotion, subject, message, target }).then(result => {
            this.target = ''
            this.subject = ''
            this.emotion = ''
            this.message = ''
            this.loading = false
            this.dialog = false
            this.snaccbar = true
          })
          .catch(error => {
            this.feedback = error.message
            this.loading = false
          })
        } else {
          this.feedback = "Please fill out the report."
        }
      }
    },
    computed: {
      breadcrumbs() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: 'breadcrumbs_dashboard',
          },
          {
            text: 'Link 1',
            disabled: false,
            to: 'breadcrumbs_link_1',
          },
          {
            text: 'Link 2',
            disabled: true,
            to: 'breadcrumbs_link_2',
          },
        ]
      } 
    },
  }
</script>
